document.addEventListener("DOMContentLoaded", function() {

  document.querySelector('#submenu').addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('anchor_btn')) {
      e.preventDefault();
  
      const targetId = e.target.getAttribute('data-target');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
  
        const headerEnd = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        const additionalOffset = parseFloat(headerEnd) || 100;
  
        const stickyHeader = document.querySelector('.sticky-header');
        const stickyHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
  
        const headerHeight = stickyHeight + additionalOffset;
  
        window.scrollTo({
          top: targetElement.offsetTop - headerHeight,
          behavior: 'smooth'
        });
  
        document.querySelectorAll('.anchor_btn').forEach(btn => btn.classList.remove('active'));
        e.target.classList.add('active');
      }
    }
  });


  document.querySelector('#menu-ancre').addEventListener('click', function(e) {
      // Prevent the default anchor behavior (which tries to navigate to the id)
      e.preventDefault();
  
      // Get the header height from the CSS custom property (variable)
      const headerEnd = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      const additionalOffset = parseFloat(headerEnd) || 100; // Default offset if variable is not set
      
      // Find the height of the sticky header
      const stickyHeader = document.querySelector('.sticky-header');
      const stickyHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
  
      // Total header height (sticky + additional offset)
      const headerHeight = stickyHeight + additionalOffset;
  
      // Find the target element with id="submenu"
      const targetElement = document.querySelector('#submenu');
  
      // If the target element exists, scroll to it with smooth behavior
      if (targetElement) {
          window.scrollTo({
              top: targetElement.offsetTop - headerHeight, // Scroll position minus header height
              behavior: 'smooth' // Smooth scrolling
          });
      }
  });


  document.querySelector('store-header').addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('anchor_btn')) {
      e.preventDefault();
  
      const targetId = e.target.getAttribute('data-target');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        const headerEnd = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
        const additionalOffset = parseFloat(headerEnd) || 100;
  
        const stickyHeader = document.querySelector('.sticky-header');
        const stickyHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
  
        const headerHeight = stickyHeight + additionalOffset;
  
        window.scrollTo({
          top: targetElement.offsetTop - headerHeight,
          behavior: 'smooth'
        });
  
        document.querySelectorAll('.anchor_btn').forEach(btn => btn.classList.remove('active'));
        e.target.classList.add('active');
      }
    }
  });


const submenuSection = document.querySelector('.submenu-section');
const storeHeader = document.querySelector('store-header');

if (submenuSection && storeHeader) {
  const submenu = document.querySelector('#submenu');
  if (submenu) {
    const submenuClone = submenu.cloneNode(true);
    
    // Change the ID of the cloned element to #submenu2
    submenuClone.id = 'submenu2';
    
    const cloneWrapper = document.createElement('div');
    cloneWrapper.id = 'submenu-section-clone';
    cloneWrapper.classList.add('submenu-section');

    cloneWrapper.appendChild(submenuClone);

    storeHeader.appendChild(cloneWrapper);

    let submenuSectionDuplicated = false;
    let initialPosition = submenuSection.offsetTop;

    const checkPosition = () => {
      const rect = submenuSection.getBoundingClientRect();
      const scrollPosition = window.scrollY;

      if (rect.top <= 0 && !submenuSectionDuplicated) {
        submenuSection.classList.remove('visible');
        cloneWrapper.classList.add('visible');
        submenuSectionDuplicated = true;
      }

      if (scrollPosition < initialPosition && submenuSectionDuplicated) {
        submenuSection.classList.add('visible');
        cloneWrapper.classList.remove('visible');
        submenuSectionDuplicated = false;
      }
    };

    const handleResize = () => {
      initialPosition = submenuSection.offsetTop;
      checkPosition();
    };

    window.addEventListener('scroll', checkPosition);
    window.addEventListener('resize', handleResize);

    checkPosition();
  }
}

});


